export default {
  main: {
    enableWinterMode: false,
    enableDigitalCashout: true,
    site_id: 18764763,
    enableWorldCup: true,
    title: 'Terminal PRO Demo',
    showBetBuilderSection: true,
    terminalId: 42254,
    enableMultipleTicketPay: true,
    isTicketsCheckable: true,
    needAdminForResetPin: false,
    ticketAvailableViewMode: ['card'],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    isWithdrawal: true,
    enableKeyboardCatching: true,
    enableThemeToggle: true,
    enableTicketTimer: true,
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    signInType: 'email',
    staffPassword: '0',
    enableRegistration: true,
    enableHeaderAdminSection: true,
    homeFavoritCompetitions: [
      {
        fileType: 'png',
        url: '/betting/prematch/all/Soccer/2570001/538',
        name: 'Football',
        classname: "layer",
      },
      {
        fileType: 'png',
        url: '/casino',
        name: 'Casino',
        classname: "layer",
      },
      {
        fileType: 'jpg',
        url: '/liveCasino',
        name: 'Live Casino',
        classname: "layer",
      },
    ],
    homeBannerSlides: [{ fileType: "jpeg", path: "/betting/prematch/all" }],
    homeMediaSlides: [
      {
        type: 'jackpot',
        path: '/betting/prematch/all',
        fileType: 'webm',
      },
      {
        type: 'deposit',
        path: '/betting/prematch/all',
      },
      {
        type: 'spin-the-wheel',
        path: '/betting/prematch/all',
      },
    ],
    websitePasswordHash: '55c019aef2fc4f743145fa6b3741b83f3c4a1f30ae1cb6ede101a429e2c469e6',

    logoSize: 'extra-huge',
    termsAndConditions: false,
    isOutlineButton: false,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    enableClientDepositMode: true,
    availableLanguages: {
      '@replace': true,
      eng: {
        short: 'EN',
        name: 'Eng',
        region: 'UnitedKingdom',
        order: 1,
      },
      // ger: {
      //   short: 'DE',
      //   name: 'Deu',
      //   order: 2,
      // },
      spa: {
        short: 'ES',
        name: 'Esp',
        region: 'UnitedKingdom',
        order: 3,
      },
      // rus: {
      //   short: 'RU',
      //   name: 'Рус',
      //   region: 'UnitedKingdom',
      //   order: 4,
      // },
      // por: {
      //   short: 'PT',
      //   name: 'Por',
      //   region: 'UnitedKingdom',
      //   order: 5,
      // },
      // swa: {
      //   short: 'SW',
      //   name: 'SWA',
      //   region: 'Kenya',
      //   order: 6,
      // },
      // tur: {
      //   short: 'TR',
      //   name: 'Tür',
      //   order: 7,
      // },
    },
  },
  balanceTransfer: {
    enableTransferToUser: true,
    enablePartialTransferToUser: true,
  },
  homePagesUrl: [
    {
      id: 1,
      url: '/betting/live',
      icon: 'global-icon icon-circle icon-a',
      className: 'live-section',
      name: 'Live',
    },
    {
      id: 3269,
      url: '/casino/75546',
      icon: 'global-icon icon-aviator custom-icons aviator',
      className: 'results-section',
      name: 'Aviator',
    },
    {
      id: 3,
      url: '/betting/results',
      className: 'results-section',
      name: 'Results',
    },
  ],
  betBuilder: {
    brandName: '',
  },
  cashout: {
    enablePartial: true,
  },
  registrationFormConfigs: {
    enabled: true,
    registrationFormSteps: [
      {
        name: 'personal_information',
        label: 'Personal',
        fields: [
          { name: 'firstName', enabled: true },
          { name: 'lastName', enabled: true },
          { name: 'birthDate', enabled: true },
          { name: 'country', enabled: true },
        ],
      },
      {
        name: 'contact_information',
        label: 'Contacts',
        fields: [
          { name: 'email', enabled: true },
          { name: 'phoneNumber', enabled: true },
          { name: 'street', enabled: true, className: 'contacts-section' },
          { name: 'city', enabled: true, className: 'contacts-section' },
          { name: 'zipCode', enabled: true, className: 'contacts-section' },
        ],
      },
      {
        name: 'credential_information',
        label: 'Credentials',
        fields: [
          { name: 'userName', enabled: true, className: 'credential-section' },
          { name: 'password', enabled: true },
          { name: 'confirmPassword', enabled: true },
        ],
      },
      {
        name: 'registrationTermsAndConditions_information',
        label: 'Final',
        fields: [
          { name: 'rull18', enabled: true },
          { name: 'termsAndConditions', enabled: true },
        ],
      },
    ],
    registrationUserName: 'userName',
  },
  wheelConfig: {
    enableWheel: true,
    isLoggedIn: false,
    spinRotationCount: 4,
    minSelectionsCount: 3,
    minSelectionOdd: 1.2,
    minOdd: 2.5,
    maxOdd: 10000000,
    maxStake: 10000000,
    minStake: 1,
    usageRules: {
      minOdd: 1.5,
      maxOdd: 50,
      minSelections: 2,
      maxSelections: 8,
    },
    wheelBoosts: [
      {
        name: 'Profit Boost',
        value: 10,
      },
      {
        name: 'Profit Boost',
        value: 25,
      },
      {
        name: 'Profit Boost',
        value: 20,
      },
      {
        name: 'Profit Boost',
        value: 15,
      },
      {
        name: 'Profit Boost',
        value: 35,
      },
    ],
  },
  lastTicketButtons: [
    {
      name: 'Bet tickets',
      type: 'betTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Lottery tickets',
      type: 'lotteryTicket',
      hideOnRestrictMode: true,
    },
    {
      name: 'Cash-out',
      type: 'cashoutTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Pay-out',
      type: 'payoutTicket',
      hideOnRestrictMode: false,
    },
  ],
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/virtuals',
          type: 'virtuals',
          name: 'Virtuals',
          enabled: true,
          icon: 'casino-categories-VirtualBetting',
          children: [
            {
              name: 'Games',
              url: 'betting/prematch/virtuals',
              icon: '',
            },
            {
              name: 'Results',
              url: 'betting/virtual-results',
              icon: '',
            },
          ],
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/racings',
          name: 'Racing',
          enabled: true,
          icon: 'racing-horse-grayhounds',
          children: [
            {
              name: 'Horses',
              url: 'betting/racings/horse-racing',
              icon: '',
            },
            {
              name: 'Greyhounds',
              url: 'betting/racings/greyhounds',
              icon: '',
            },
          ],
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
        {
          type: 'multiplesOfTheDay',
          name: 'Multiples of the day',
          enabled: false,
          icon: 'flash',
        },
        // {
        //   type: 'boostedOdds',
        //   name: 'Boosted Odds',
        //   enabled: false,
        //   icon: 'boosted-odd',
        // },
        {
          type: 'today',
          name: 'Today',
          enabled: false,
          icon: 'boosted-odd',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
      nestedItems: [
        {
          name: 'Casino',
          type: 'casino',
          url: 'casino',
          enabled: true,
          icon: 'casino-7',
        },
        {
          name: 'Live Casino',
          type: 'liveCasino',
          url: 'liveCasino',
          enabled: true,
          icon: 'casino-categories-LotteryGames',
        },
      ],
    },
    {
      name: 'Virtual Games',
      url: 'thirdPartyGame/400002',
      type: 'virtualGames',
      enabled: true,
      nestedItems: [
        {
          url: 'thirdPartyGame/400002',
          name: 'Golden Race',
          type: 'goldenRace',
          iframeFullscreen: false,
          enabled: true,
          icon: 'golden-race',
          gameId: '400002',
          gameWithSecondScreen: false,
          onlyInHeader: true,
        },
        // {
        //   url: 'thirdPartyGame/555572885',
        //   name: 'Grecia Kino Luck 5',
        //   type: 'greciaKinoLuck5',
        //   iframeFullscreen: false,
        //   enabled: true,
        //   // icon: 'golden-race',
        //   gameId: '555572885',
        //   gameWithSecondScreen: false,
        //   onlyInHeader: true,
        // },
        // {
        //   url: 'thirdPartyGame/10913',
        //   name: 'Atlas Gaming',
        //   type: 'goldenRace',
        //   iframeFullscreen: false,
        //   enabled: true,
        //   icon: 'golden-race',
        //   gameId: '10913',
        //   gameWithSecondScreen: false,
        //   onlyInHeader: true,
        // },
        {
          url: 'thirdPartyGame/156147',
          name: 'Pascal Gaming',
          type: 'pascalGaming',
          enabled: true,
          iframeFullscreen: false,
          gameId: '156147',
          icon: 'casino-categories-PGgames',
          gameWithSecondScreen: false,
          onlyInHeader: false,
        },
        // {
        //   url: 'thirdPartyGame/10412176',
        //   name: 'Pool Masters',
        //   type: 'poolMasters',
        //   enabled: true,
        //   icon: 'win-cup',
        //   iframeFullscreen: false,
        //   gameId: '10412176',
        //   gameWithSecondScreen: false,
        //   hasNewLabel: true,
        // },
        // {
        //   url: 'thirdPartyGame/400040300',
        //   name: 'Lucky 6',
        //   type: 'lucky6',
        //   enabled: true,
        //   // icon: 'win-cup',
        //   iframeFullscreen: false,
        //   gameId: '400040300',
        //   gameWithSecondScreen: false,
        //   hasNewLabel: true,
        // },
        {
          url: 'thirdPartyGame/112008',
          name: 'Diamond X',
          type: 'diamondX',
          hasNewLabel: true,
          icon: 'diamond-x',
          enabled: false,
          iframeFullscreen: false,
          gameId: '112008',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112007',
          name: "Joker's Luck",
          type: 'jockersLuck',
          hasNewLabel: false,
          icon: 'jockers-luck',
          enabled: false,
          iframeFullscreen: false,
          gameId: '112007',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112005',
          name: 'Rocket Jet',
          type: 'rocketJet',
          icon: 'rocket-jet',
          enabled: false,
          iframeFullscreen: false,
          gameId: '112005',
          onlyInHeader: true,
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112002',
          name: 'Book of 6',
          type: 'bookOf6',
          icon: 'book-of-six',
          enabled: false,
          iframeFullscreen: false,
          gameId: '112002',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112001',
          name: 'Loto',
          type: 'loto',
          icon: 'loto',
          enabled: false,
          iframeFullscreen: false,
          gameId: '112001',
          gameWithSecondScreen: false,
        },
      ],
    },
    // {
    //   url: 'casino-category/406',
    //   name: 'Crash Games',
    //   enabled: true,
    // },
    {
      url: 'tickets',
      name: 'Tickets',
      enabled: true,
    },
  ],
  defaultTerminalParams: {
    pid: 18764763,
    tid: 42254,
    token: 'bBeXMA==',
    currency: 'HNL'
  },
  // defaultTerminalParams: { pid: 1001, tid: 378, token: "l54kAA==", currency: "AMD" },
  betslip: {
    enableCounterOffer: true,
    enableExpressCounterOffer: true,
    enableBookingBet: true,
    enableBankerBet: true,
    bookingBetBalanceMaxLimit: 9999999,
  },
  upperScreen: {
    statisticsLive: false,
    statisticsPrematch: true,
    liveStreaming: true,
    liveAnimations: true,
  },
  sportsbook: {
    enableBannerAnimation: true,
    asianViewMarket: {
      Soccer: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "DOUBLE CHANCE",
              side: ["1X", "12", "X2"],
            },
            {
              display_key: "NEXTGOALTOSCORE",
              title: "NEXT GOAL TO SCORE",
              side: ["Home", "No", "Away"],
            },
          ],
          [
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              display_key: "DRAWNOBET",
              title: "DRAW NO BET",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
            {
              display_key: "ODD/EVEN",
              market_type: {
                "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"],
              },
              title: "Total Goals: Even/Odd",
              side: ["Even", "Odd"],
            },
            {
              display_key: "HANDICAP",
              market_type: {
                "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"],
              },
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "CARDSTOTALS",
              title: "Yellow Cards: Total",
              side: ["Over", "Under"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "DOUBLE CHANCE",
              market_type: {
                "@in": ["DoubleChance", "HalfTimeDoubleChance", "SecondHalfDoubleChance",],
              },
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals",
              side: ["Over", "Under"],
              alt_main_order: 1,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
          ],
          [
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              display_key: "DRAWNOBET",
              title: "DRAW NO BET",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              market_type: {
                "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"],
              },
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "CARDSTOTALS",
              title: "Yellow Cards: Total",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      CyberFootball: {
        prematch: [
          [{
            display_key: "WINNER",
            title: "Winner",
            side: ["P1", "X", "P2"],
          }],
        ],
        live: [
          [{
            display_key: "WINNER",
            title: "Winner",
            side: ["P1", "X", "P2"],
          }],
        ],
      },
      Tennis: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "SetHandicap",
              title: "Set Games Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["SetOverUnder", "TotalGamesOver/Under"],
              },
              title: "SET TOTAL GAMES",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
              },
              title: "TOTAL GAMES ODD OR EVEN",
              side: ["Even", "Odd"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "Handicap",
              title: "Games Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["SetOverUnder", "TotalGamesOver/Under"],
              },
              title: "TOTAL GAMES",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
              },
              title: "TOTAL GAMES ODD OR EVEN",
              side: ["Even", "Odd"],
            },
          ],
        ],
      },
      Basketball: {
        live: [
          [
            {
              title: "Overtime",
              market_type: "Overtime",
              side: ["Yes", "No"],
            },
            {
              display_key: "HANDICAP",
              title: "Points Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Match Total",
              side: ["Over", "Under"],
            },
            {
              display_key: "ODD/EVEN",
              title: "Match Total Odd/Even",
              side: ["Even", "Odd"],
            },
          ],
        ],
        prematch: [
          [
            {
              market_type: "MatchWinner2",
              // display_key: "WINNER",
              title: "Match Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Match Handicap",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              title: "Match Total",
              side: ["Over", "Under"],
            },
            {
              display_key: "ODD/EVEN",
              title: "Match Total Odd/Even",
              side: ["Even", "Odd"],
            },
          ],
        ],
      },
      IceHockey: {
        live: [
          [
            {
              display_key: "WINNER",
              market_type: "MatchWinner3",
              title: "Match Result (Regular Time)",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "Double chance (Regular Time)",
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "WINNER",
              title: "Match Winner (Including Overtime)",
              market_type: "MatchWinner2",
              side: ["P1", "P2"],
            },
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both Teams To Score (Regular Time)",
              side: ["Yes", "No"],
            },
            {
              market_type: {
                '@in': ['MatchTotal2', 'PeriodTotal2'],
              },
              display_key: 'TOTALS',
              title: 'Total (Regular Time)',
              side: ['Over', 'Under'],
            },
            {
              market_type: {
                '@in': ['MatchHandicap2', 'PeriodHandicap2'],
              },
              display_key: 'HANDICAP',
              title: 'Handicap (Regular Time)',
              side: ['Home', 'Away'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              market_type: "MatchWinner3",
              title: "Match Result (Regular Time)",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "Double chance (Regular Time)",
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "WINNER",
              title: "Match Winner (Including Overtime)",
              market_type: "MatchWinner2",
              side: ["P1", "P2"],
            },
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both Teams To Score (Regular Time)",
              side: ["Yes", "No"],
            },
            {
              market_type: {
                '@in': ['MatchTotal2', 'PeriodTotal2'],
              },
              display_key: 'TOTALS',
              title: 'Total (Regular Time)',
              side: ['Over', 'Under'],
            },
            {
              market_type: {
                '@in': ['MatchHandicap2', 'PeriodHandicap2'],
              },
              display_key: 'HANDICAP',
              title: 'Handicap (Regular Time)',
              side: ['Home', 'Away'],
            },
          ],
        ],
      },
      Volleyball: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "HANDICAP",
              title: "Match points Handicap",
              side: ["Home", "Away"],
            },
            {
              market_type: "TOTALS",
              title: "Total points",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              market_type: {
                "@in": ["MatchHandicap2", "PeriodHandicap2"],
              },
              display_key: "HANDICAP",
              title: "Handicap (Regular Time)",
              side: ["Home", "Away"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              display_key: "HANDICAP",
              // market_type: "MatchTotalPointsHandicap",
              title: "Points Handicap",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              // market_type: "MatchTotalPointsOverUnder",
              title: "Total points",
              side: ["Over", "Under"],
            },
          ],
          [
            {
              market_type: {
                "@in": ["MatchHandicap2", "PeriodHandicap2"],
              },
              display_key: "HANDICAP",
              title: "Handicap (Regular Time)",
              side: ["Home", "Away"],
            },
          ],
        ],
      },
      Pesapallo: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Handball: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      BallHockey: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Match Result',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Futsal: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      RugbyLeague: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      RugbyUnion: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      WaterPolo: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
            },
          ],
        ],
      },
      Darts: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: "TotalSetsOver/Under",
              title: "TOTAL SETS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: "TotalSetsOver/Under",
              title: "TOTAL SETS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Chess: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      default: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
    },
  },
};
